import { hasPermission, IPermissionCode } from "../../../utils/hasPermission";
import {
  PageContainer,
  PageHeader,
  PageTitle,
  ErrorMessage,
} from "./AdminPage.styles";

interface IRequirePagePermissionProps {
  permission: IPermissionCode;
  children: JSX.Element;
}

/**
 * Route-level gate for the EN-5129 per-page /admin permissions: renders the
 * page only when the user holds its permission, otherwise a friendly denial
 * (the API enforces the same permission on the page's endpoints, so this is
 * UX, not the security boundary). Wrap every migrated page's route element:
 *
 *   <RequirePagePermission permission={PERMISSIONS.BILLABLE_DEVICES_ACCESS}>
 *     <AdminBillableDevices />
 *   </RequirePagePermission>
 */
export function RequirePagePermission({
  permission,
  children,
}: IRequirePagePermissionProps) {
  if (!hasPermission(permission)) {
    return (
      <PageContainer>
        <PageHeader>
          <PageTitle>Access denied</PageTitle>
        </PageHeader>
        <ErrorMessage>
          Your account doesn&apos;t have access to this page. Ask an
          administrator to grant it if you need it.
        </ErrorMessage>
      </PageContainer>
    );
  }

  return children;
}
